import { render, staticRenderFns } from "./Stakeholder.vue?vue&type=template&id=c62593ba&scoped=true&"
import script from "./Stakeholder.vue?vue&type=script&lang=js&"
export * from "./Stakeholder.vue?vue&type=script&lang=js&"
import style0 from "./Stakeholder.vue?vue&type=style&index=0&id=c62593ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62593ba",
  null
  
)

export default component.exports